<template>
  <div class="row justify-content-center align-items-md-center">
    <div class="col-md-8">
      <div class="card full-height bg-ligth">
        <div class="card-header">
          <h3 class="mb-0">Gerenciar Tipo Examen</h3>
        </div>
        <div class="card-body">
          <div class="form-group row justify-content-center align-items-md-center">
            <div class="col-md-12">
              <input required type="text" class="form-control" v-model="filtro"
                placeholder="Buscar por nombre o codigo" />
            </div>
          </div>

          <b-table :fields="['nome', 'codigo', 'descricao', 'status', 'acoes']" :items="lista_tipo_exames"
            :per-page="perPage" :current-page="currentPage" id="tipo_exame-table" class="
              table
              table-head-custom
              table-vertical-center
              table-head-bg
              table-borderless
            " show-empty empty-text="Ningún registro encontrado!">
            <template #head(nome)>Nombre</template>
            <template #head(codigo)>Codigo</template>
            <template #cell(status)="{ item }">
              <div class="text-right w-100">
                <span v-if="item.status == 1" class="label label-lg label-inline label-light-success">activo</span>
                <span v-if="item.status == 2" class="label label-lg label-inline label-light-warning">inactivo</span>
                <span v-if="item.status == 0" class="label label-lg label-inline label-light-error">excluido</span>
              </div>
            </template>
            <template #head(descricao)>Descripción</template>
            <template #head(acoes)><span></span></template>
            <template #cell(acoes)="{ item }">
              <div class="text-right w-100">
                <button v-show="lista_permissoes_filial.u_Exame" @click="atualizar(item)"
                  class="btn btn-icon btn-light btn-sm mx-1" v-b-tooltip.hover title="Editar registro">
                  <i class="far fa-edit text-primary"></i>
                </button>


                <button v-show="lista_permissoes_filial.lock_Exame" @click="confirm(item.id, item.status)"
                  class="btn btn-icon btn-light btn-sm mx-1" v-b-tooltip.hover title="Activar/Inactivar registro">
                  <i v-if="item.status == 2" class="fas fa-unlock-alt text-info"></i>
                  <i v-else="item.status == 2" class="fas fa-lock text-info"></i>
                </button>

                <button v-show="lista_permissoes_filial.d_Exame" @click="confirm(item.id, 0)"
                  class="btn btn-icon btn-light btn-sm mx-1" v-b-tooltip.hover title="Excluir registro">
                  <i class="far fa-trash-alt text-danger"></i>
                </button>
              </div>
            </template>
          </b-table>
          <b-pagination v-model="currentPage" :total-rows="lista_tipo_exames.length" :per-page="perPage"
            aria-controls="tipo_exame-table">
          </b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      filtro: "",
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Tipo de Examenes" }]);
  },
  created() {
    this.listar_tipo_exames();
  },
  watch: {
    filtro() {
      if (this.filtro.length >= 2) this.pesquisar_tipo_exames()
      if (this.filtro.length < 2) this.listar_tipo_exames()
    },
  },
  computed: {
    lista_tipo_exames() {
      return this.$store.state.tipo_exame.lista_tipo_exames;
    },
    lista_permissoes_filial() {
      return this.$store.state.sistema.lista_permissoes_filial;
    },
    mensagem_alert() {
      return this.$store.state.tipo_exame.mensagem_alert;
    },
  },
  methods: {
    async listar_tipo_exames() {
      this.$store.dispatch("configEmpresa/MudarPreloader", true);
      await this.$store
        .dispatch("tipo_exame/listar_tipo_exames")
        .finally(() => {
          this.$store.dispatch("configEmpresa/MudarPreloader", false);
          this.$store.dispatch("configEmpresa/atualizar", "");
        });
    },

    async pesquisar_tipo_exames() {
      if (this.filtro == "") {
        await this.listar_tipo_exames()
      } else {
        await this.$store
          .dispatch("tipo_exame/pesquisar_tipo_exames", this.filtro)
          .finally(() => {
            this.$store.dispatch("configEmpresa/atualizar", "");
          });
      }


    },

    atualizar(value) {
      this.$router.push({ name: "createTipoExame" });
      this.$store.dispatch("configEmpresa/atualizar", value);
    },

    async confirm(value, status) {
      let acao = 'desactiva'
      if (status == 2) acao = 'activa'
      if (status == 0) acao = 'exclui'
      await this.$confirm({
        title: "Estas seguro?",
        message: 'Esta ação ' + acao + ' el Tipo de Examen.',
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            if (status == 1) this.bloquear(value);
            if (status == 2) this.desbloquear(value);
            if (status == 0) this.exclui(value);
          }
        },
      });
    },
    async bloquear(value) {
      await this.$store.dispatch("tipo_exame/bloquear_tipo_exame", value);
      this.alertMessage(this.mensagem_alert.tipo, this.mensagem_alert.message);
      await this.pesquisar_tipo_exames()
    },
    async desbloquear(value) {
      await this.$store.dispatch("tipo_exame/desbloquear_tipo_exame", value);
      this.alertMessage(this.mensagem_alert.tipo, this.mensagem_alert.message);
      await this.pesquisar_tipo_exames()
    },
    async exclui(value) {
      await this.$store.dispatch("tipo_exame/delete_tipo_exame", value);
      this.alertMessage(this.mensagem_alert.tipo, this.mensagem_alert.message);
      await this.pesquisar_tipo_exames()
    },
    alertMessage(tipo, mensagem) {
      this.$fire({
        title: "Aviso",
        text: mensagem,
        type: tipo,
        timer: 3000,
      }).then((r) => {
        console.log(r.value);
      });
    },
  },
};
</script>

<style scoped>
.lista:hover {
  background-color: rgba(167, 183, 255, 0.705);
}
</style>